/*eslint-disable*/
import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import Axios from 'axios';

import APP_CONSTANTS from '../../config/constants';

const BranchDropdown = ({
    field: { name, value },
    form: { setFieldValue },
    getMasterBranchSelected,
    getBranchStateMapId,
    ...props
}) => {
    const [branch, setBranch] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [selectedBrannch, setSelectedBranch] = useState(null);

    useEffect(() => {
        setIsLoading(true)
        let token = localStorage.getItem('apiToken')
        let userId = localStorage.getItem('userId')
        let customerNo = localStorage.getItem('customerNo')
        let data = JSON.stringify
            ({
                "customerNumber": customerNo,
                "userId": userId,
                "customer_no": customerNo,
                "user_id": userId,
                "customerNo": customerNo
            })

        Axios.post(`${APP_CONSTANTS.BASE_URL}masters/branch`, data, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then((response => {
            setBranch(response.data.resultSet)
            getMasterBranchSelected && getMasterBranchSelected(purchaseOrderDetails[0].branchCode, response.data.resultSet)
            setIsLoading(false)
        }))
            .catch(error => console.log(error))
        setIsLoading(false)
    }, [])

    useEffect(() => {
        if (props.value) {
            branch.map((object) => {
                if (object.branchCode == props.value) {
                    if (getBranchStateMapId !== null && getBranchStateMapId !== undefined) {
                        getBranchStateMapId(object.stateId)
                    }
                }
            })
        }
    }, [props, branch])

    let options = []
    if (branch && branch.length > 0) {
        branch.map((object, index) => {
            let temp = {}
            temp.key = object.branchCode
            temp.text = object.branchName
            temp.value = object.branchCode
            temp.gstChargeMechanism = object.gstChargeMechanism
            temp.GSTExemptedReasonName = object.GSTExemptedReasonName
            temp.isGSTApplicable = object.isGSTApplicable
            temp.gstNo = object.gstNo
            return options[index] = temp
        })
    }

    const handleOnChange = (data, branch) => {
        branch.map((object) => {
            if (object.branchCode == data.value) {
                setSelectedBranch(object.gstChargeMechanism === 'RCM' ? `GST Charge Mechanism : RCM` : null)
                if (getBranchStateMapId !== null && getBranchStateMapId !== undefined) {
                    getBranchStateMapId(object.stateId, data)
                }
            }
        })
        props.setBranchCode && props.setBranchCode(data.value)
    }

    return (
        <>
            <Dropdown
                selection
                search
                onChange={(value, data) => { setFieldValue(name, data.value); getMasterBranchSelected && getMasterBranchSelected(data.value, branch); handleOnChange(data, branch) }}
                options={options}
                clearable
                loading={isLoading}
                {...props}
                fluid
            />
            <span style={{ color: '#006837', fontWeight: 600, marginTop: '10px' }}>{selectedBrannch}</span>
        </>
    )
}

export default BranchDropdown
